import { isAllowedWebUrl } from "common/functions/security";
import React from "react";
import { SafeExternalLinkProps } from "./types";

export const SafeExternalLink = React.memo((props: SafeExternalLinkProps) => {
  const url = props.url ?? "";

  if (!url || !isAllowedWebUrl(url)) {
    return <span>{url || props.children}</span>;
  }

  return (
    <a href={url} target="_blank" rel="noopener noreferrer">
      {props.children ?? url}
    </a>
  );
});
